import React from 'react'
import { cn } from '@/lib/utils'

interface MicrosoftProviderIconProps {
  provider: 'onedrive' | 'sharepoint'
  className?: string
}

const ICON_SOURCES: Record<MicrosoftProviderIconProps['provider'], { src: string; alt: string }> = {
  onedrive: {
    src: '/microsoft-onedrive.svg',
    alt: 'OneDrive logo'
  },
  sharepoint: {
    src: '/microsoft-sharepoint.svg',
    alt: 'SharePoint logo'
  }
}

export function MicrosoftProviderIcon({ provider, className }: MicrosoftProviderIconProps) {
  const icon = ICON_SOURCES[provider]

  return (
    <img
      src={icon.src}
      alt={icon.alt}
      className={cn('h-4 w-4 object-contain', className)}
    />
  )
}
